import { type FC } from 'react';
import { Paper, Stack, Text } from '@mantine/core';
import { type PayoutTraderStatus, type PayoutTraderWorkingStatus } from '~/entities/payout';
import { KeyValuePair } from '~/shared/ui/KeyValuePair';
import { TraderStatusBadge } from '../TraderStatusBadge';
import { WorkingStatusField } from './components';

interface TraderStateCardProps {
    canEditWorkingStatus: boolean;
    isWorkingStatusPending: boolean;
    onWorkingStatusChange: (workingStatus: PayoutTraderWorkingStatus) => void;
    status?: PayoutTraderStatus;
    traderId?: string;
    workingStatus?: PayoutTraderWorkingStatus;
}

export const TraderStateCard: FC<TraderStateCardProps> = ({
    canEditWorkingStatus,
    isWorkingStatusPending,
    onWorkingStatusChange,
    status,
    traderId,
    workingStatus,
}) => {
    return (
        <Paper
            p='md'
            radius='md'
            withBorder
        >
            <Stack gap='sm'>
                <Text
                    fw={600}
                    size='sm'
                >
                    Состояние
                </Text>

                <Stack gap='xs'>
                    <KeyValuePair
                        label='Статус'
                        value={<TraderStatusBadge status={status} />}
                    />

                    {traderId && (
                        <KeyValuePair
                            label='Статус работы'
                            value={
                                <WorkingStatusField
                                    workingStatus={workingStatus}
                                    canEdit={canEditWorkingStatus}
                                    isPending={isWorkingStatusPending}
                                    onChange={onWorkingStatusChange}
                                />
                            }
                        />
                    )}
                </Stack>
            </Stack>
        </Paper>
    );
};
